














































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { IndexBar, IndexAnchor, Cell, Button, Search, Icon } from "vant";
import { getBrowser } from "@/utils/browser";
const browser = getBrowser();

const createAccountModule = namespace("createAccount");

@Component({
  name: 'CountryList',
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Search.name]: Search,
    [Icon.name]: Icon
  }
})
export default class CountryList extends Vue {
  @createAccountModule.Getter("currentCountry") getterCurrentCountry: any;
  @createAccountModule.Mutation("SAVE_CURRENT_COUNTRY") saveCurrentCountry;
  keyword = "";
  isNoSearchResult = false;
  currentCountry: any = {};
  countryList = [];
  resultList = [];
  isApp = browser.isApp;

  //   @Watch("getter_tax_place", { deep: true, immediate: true })
  //   watchTaxPlace(val) {
  //     
  //     this.checkedCountryList = val.extra;
  //   }

  created() {
    // this.countryList = this.country_list.normal;
    (this as any).$apis
      .getAllCountryList()
      .then(res => {
        this.countryList = res;
        this.resultList = res;
      })
      .catch(e => {
        
      });
  }

  activated() {
    this.currentCountry = this.getterCurrentCountry;
  }

  handleCountryItemClick(item) {
    this.currentCountry = item;
    const { id, name } = item;
    
    this.saveCurrentCountry({ id, name });
    this.$router.go(-1);
  }

  handleConfirmCountryList() {
    this.$router.go(-1);
  }

  handleSearch(value) {
    this.resultList = this.countryList.filter(item => {
      return (item as any).name.indexOf(value) > -1;
    });
    if (this.resultList.length == 0) {
      this.isNoSearchResult = true;
    } else {
      this.isNoSearchResult = false;
    }
  }
}
